import { render } from "./Pilares.vue?vue&type=template&id=5299f33d"
import script from "./Pilares.vue?vue&type=script&lang=js"
export * from "./Pilares.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__